// One guarded line of tactile commit-acknowledgment (§Q3 INCLUDE, 11 A2). Opt-in by platform:
// `navigator.vibrate` is undefined where the platform has not opted in (desktop, iOS Safari),
// so this is a silent no-op there and never throws. A short 10ms tick - acknowledgment, not
// celebration.
export const commitHaptic = () => {
  if (typeof navigator !== "undefined" && typeof navigator.vibrate === "function") {
    navigator.vibrate(10);
  }
};
